import { keyframes, styled } from "@mui/material";

const shiftGradient = keyframes({
  "0%, 100%": { backgroundPosition: "0% 50%" },
  "50%": { backgroundPosition: "100% 50%" },
});

export const StyledFooter = {
  Root: styled("footer")(({ theme }) => ({
    position: "relative",
    background: theme.custom.colors.navy950,
    color: "rgba(255, 255, 255, 0.72)",
    paddingTop: "clamp(40px, 6vw, 70px)",
  })),

  Cta: styled("div")(({ theme }) => ({
    transform: "translateY(-50%)",
    marginBottom: "calc(-1 * clamp(30px, 4vw, 48px))",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 26,
    flexWrap: "wrap",
    padding: "clamp(30px, 4vw, 46px) clamp(28px, 4vw, 52px)",
    borderRadius: theme.custom.radius.lg,
    background: theme.custom.gradient.brand,
    backgroundSize: "160% 160%",
    animation: `${shiftGradient} 8s ease infinite`,
    boxShadow: "0 30px 60px -25px rgba(23, 79, 155, 0.6)",
    "& h2": {
      color: "#fff",
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "clamp(1.5rem, 3vw, 2.1rem)",
    },
    "& p": { color: "rgba(255, 255, 255, 0.9)", marginTop: 8 },
  })),

  Inner: styled("div")({
    display: "grid",
    gridTemplateColumns: "1.6fr 1fr 1.2fr 1.2fr",
    gap: 40,
    paddingBlock: "clamp(30px, 4vw, 48px)",
    "@media (max-width: 900px)": { gridTemplateColumns: "1fr 1fr" },
    "@media (max-width: 560px)": { gridTemplateColumns: "1fr" },
  }),

  Brand: styled("div")({
    "& p": {
      marginTop: 16,
      maxWidth: "34ch",
      fontSize: "0.94rem",
      lineHeight: 1.65,
    },
  }),

  Socials: styled("div")({
    marginTop: 20,
    display: "flex",
    gap: 10,
    "& a": {
      width: 40,
      height: 40,
      display: "grid",
      placeItems: "center",
      borderRadius: 11,
      color: "#fff",
      background: "rgba(255, 255, 255, 0.08)",
      border: "1px solid rgba(255, 255, 255, 0.12)",
      transition: "transform 0.25s ease, background 0.25s ease",
      "& svg": { fontSize: "1.15rem" },
    },
    "& a:hover": {
      transform: "translateY(-3px)",
      background: "linear-gradient(120deg, #4BA3E0, #2E6FD6)",
    },
  }),

  Col: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: 12,
    "& h4": {
      color: "#fff",
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "0.95rem",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      marginBottom: 4,
    },
    "& a": {
      display: "inline-flex",
      alignItems: "center",
      gap: 9,
      fontSize: "0.93rem",
      color: "rgba(255, 255, 255, 0.66)",
      transition: "color 0.2s ease",
      "& svg": { fontSize: "1.05rem" },
    },
    "& a:hover": { color: "#8AC2EC" },
  })),

  Certs: styled("div")({
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 10,
    "& span": {
      fontSize: "0.74rem",
      padding: "5px 11px",
      borderRadius: "999px",
      background: "rgba(255,255,255,0.06)",
      border: "1px solid rgba(255,255,255,0.12)",
      color: "rgba(255,255,255,0.8)",
    },
  }),

  Bottom: styled("div")({
    borderTop: "1px solid rgba(255, 255, 255, 0.08)",
    paddingBlock: "24px 34px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
    flexWrap: "wrap",
    fontSize: "0.84rem",
    textAlign: "center",
  }),

  Quality: styled("p")({
    maxWidth: "52ch",
    color: "rgba(255,255,255,0.5)",
    textAlign: "right",
    "@media (max-width: 560px)": { textAlign: "center" },
  }),
};
